import * as fromDatatype from "../datatype-library/index";

export interface bl_del_vehicle_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  reg_plate: fromDatatype.VarcharDatatypeInterface;
  brand: fromDatatype.VarcharDatatypeInterface;
  model: fromDatatype.VarcharDatatypeInterface;
  model_year: fromDatatype.IntegerDatatypeInterface;
  engine_capacity: fromDatatype.VarcharDatatypeInterface;
  vehicle_capacity: fromDatatype.VarcharDatatypeInterface;
  purchased_date: fromDatatype.TimestampTzDatatypeInterface;
  vehicle_status: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_del_vehicle_hdr_RowClass
  implements bl_del_vehicle_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  reg_plate: fromDatatype.VarcharDatatypeInterface;
  brand: fromDatatype.VarcharDatatypeInterface;
  model: fromDatatype.VarcharDatatypeInterface;
  model_year: fromDatatype.IntegerDatatypeInterface;
  engine_capacity: fromDatatype.VarcharDatatypeInterface;
  vehicle_capacity: fromDatatype.VarcharDatatypeInterface;
  purchased_date: fromDatatype.TimestampTzDatatypeInterface;
  vehicle_status: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}
